import { accessEntries } from "@/mocks/blackmole";

export default function AccessCta() {
  return (
    <section id="access" className="scroll-mt-24 bg-foreground-950 text-background-100">
      <div className="mx-auto w-full max-w-[1240px] px-4 py-14 md:px-6 md:py-20">
        <div className="mx-auto max-w-2xl text-center">
          <span className="inline-flex items-center gap-1.5 rounded-full bg-primary-500 px-3 py-1 text-xs font-semibold text-background-50">
            <i className="ri-send-plane-fill text-xs"></i>
            抢先版入口
          </span>
          <h2 className="mt-4 font-heading text-2xl font-bold text-background-50 md:text-4xl">
            突发爆料，永远比别人早一步点开
          </h2>
          <p className="mt-3 text-sm leading-relaxed text-background-200/80 md:text-base">
            最新猛料即时更新，快讯速递不设缓冲。选一个入口，把第一现场的主动权拿回手里。
          </p>
        </div>

        <div className="mt-10 grid gap-4 md:grid-cols-3">
          {accessEntries.map((e) => (
            <div
              key={e.title}
              className="group flex flex-col rounded-xl bg-background-50/5 p-6 ring-1 ring-inset ring-background-50/10 transition-colors hover:bg-background-50/10"
            >
              <span
                className={`flex h-12 w-12 items-center justify-center rounded-lg text-xl text-background-50 ${
                  e.tone === "primary"
                    ? "bg-primary-500"
                    : e.tone === "accent"
                      ? "bg-accent-500 text-foreground-950"
                      : "bg-secondary-500"
                }`}
              >
                <i className={e.icon}></i>
              </span>
              <h3 className="mt-5 text-lg font-semibold text-background-50">{e.title}</h3>
              <p className="mt-2 flex-1 text-sm leading-relaxed text-background-200/80">{e.desc}</p>
              <button
                type="button"
                className="mt-6 inline-flex w-full items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-50/25 py-2.5 text-sm font-semibold text-background-50 transition-colors group-hover:border-background-50 group-hover:bg-background-50 group-hover:text-foreground-950"
              >
                {e.action}
                <i className="ri-arrow-right-line text-sm"></i>
              </button>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}